import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
import CreateAxios from "../axiosComponent/create";
import ModalCreateConsignee from "../createShipmentComponent/modalCreateConsignee";

const ConsigneeWithCreate = ({
  field: { name },
  form: { setFieldValue },
  fillAddressState,
  ...props
}) => {
  const [consignee, setConsignee] = useState([]);
  const [isloading, setisloading] = useState(false);
  let [addedConsignee, setAddedConsignee] = useState(false);
  let [Txt, setTxt] = useState("");

  useEffect(() => {
  }, [addedConsignee]);

  let handleSearch = (e, data) => {
    // if (data.searchQuery.length > 1) {
    setisloading(true);
    let searchTerm = data.searchQuery;
    setTxt(data.searchQuery);
    setFieldValue(name, data.value);
    CreateAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/consigneeMaster`,
      payload: { searchTerm: searchTerm },
    }).then((result) => {
      setConsignee(result.data.resultSet);
      setisloading(false);
    });
    // }
  };

  let handleChange = (value, data) => {
    let filteredoptions = consignee.filter(
      (item) => item.consigneeCode == data.value
    );
    setFieldValue(name, data.value);

    if (props?.consigneeRaw) {
      setFieldValue(props.consigneeRaw, filteredoptions[0]);
    }

    if (props?.consigneeRaw && props?.consignee_placeholder) {
      let selected = data.options.filter((object, index) => {
        if (object.value == data.value) {
          return object.text
        }
      });
      setFieldValue(props.consigneeRaw, selected?.[0]);
      setFieldValue(props.consignee_placeholder, selected?.[0]?.text);
    }
  };

  const setAddedConsigneeFetch = () => {
    setAddedConsignee(!addedConsignee);
  };

  let consigneeNames = [];

  if (consignee.length > 0) {
    const filterdBillers = consignee.filter(obj => { return obj.consigneeName.toLowerCase().startsWith(Txt) })
    filterdBillers.map((object, index) => {
      let temp = {};
      temp.key = object.consigneeId;
      temp.text = `${object.consigneeName} (${object.consigneeCode})`;
      temp.value = object.consigneeCode;
      temp.raw = { ...object };
      return (consigneeNames[index] = temp);
    });
  }

  let OptionsList = consigneeNames.sort((a, b) => a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1);
  return (
    <div className="display-flex-center width-100cent">
      <div className="consignee_dropdown">
        <Dropdown
          selection
          search
          clearable
          loading={isloading}
          style={{ width: "100%" }}
          placeholder={props.placeholder}
          onChange={handleChange}
          options={OptionsList}
          onSearchChange={handleSearch}
          {...props}
        />
      </div>
      <div className="create-modal-master">
        <ModalCreateConsignee reFetchConsignee={setAddedConsigneeFetch} />
      </div>
    </div>
  );
};

export default ConsigneeWithCreate;
